import _ from "lodash"

export const getAuthToken = (auth) => _.get(auth,['data','token'],'')
export const getAuthUser = (auth) => _.get(auth,['data','user'],'')

export const getAuthIsLogout = auth => _.get(auth,['auth','isLogout'],false)
